// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2GEaf","copy":"style_copy__3dqRt"};